import { render, staticRenderFns } from "./WordVis.vue?vue&type=template&id=2786cdb8&scoped=true&"
import script from "./WordVis.vue?vue&type=script&lang=js&"
export * from "./WordVis.vue?vue&type=script&lang=js&"
import style0 from "./WordVis.vue?vue&type=style&index=0&id=2786cdb8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2786cdb8",
  null
  
)

export default component.exports